import { createContext, useContext } from "react";
import type { RouterOutputs } from "@remi/api";
import { RemiErrorDeprecated } from "@remi/error";

export type Bid = RouterOutputs["bid"]["getBid"];
export type Person = NonNullable<RouterOutputs["person"]["byId"]>;

export type StartAgreementDrawerConfig = {
  readOnly: boolean;
  bid: Bid;
  homeowner: Person;
  quoteVersionOverrideId?: string;
  requestForQuoteId: number;
  taskId: string;
  isHrmAssigned: boolean;
  isTaskCompleted: boolean;
};

const StartAgreementDrawerContext = createContext<{
  openStartAgreement: (config: StartAgreementDrawerConfig) => void;
} | null>(null);

export const useStartAgreementDrawer = () => {
  const ctx = useContext(StartAgreementDrawerContext);
  if (!ctx) {
    throw new RemiErrorDeprecated({
      message: "useStartAgreementDrawer must be used within StartAgreementDrawerProvider",
    });
  }
  return ctx;
};

export { StartAgreementDrawerContext };
